<template>
    <div>
        <div class="page-header pr-0">
            <h2>
                <a href="/dashboard"><i class="fas fa-tachometer-alt"></i></a>
            </h2>
            <ol class="breadcrumbs">
                <li class="active"><span>RECEPCIÓN</span></li>
            </ol>
            <div class="right-wrapper pull-right">
                <div class="btn-group flex-wrap">
                    <button
                        class="btn btn-custom btn-sm mt-2 mr-2"
                        type="button"
                        @click="onGotoBack"
                    >
                        <i class="fa fa-arrow-left"></i> Atras
                    </button>
                </div>
            </div>
        </div>
        <div class="card mb-0">
            <div class="card-header bg-info">
                <h3 class="my-0">{{ title }}</h3>
            </div>
            <div class="card-body">
                <div class="row justify-content-between">
                    <div class="col-12">
                        <div style="display: flex; justify-content: space-between; align-items: center;">
                            <div class="form-group">
                                <label class="control-label">Serie</label>
                                <el-select v-model="serie_id" placeholder="Seleccione una serie"    
                                    @change="onChangeSerie"
                                >
                                    <el-option v-for="serie in series"
                                        :key="serie.id"
                                        :value="serie.id"
                                        :label="serie.number"
                                    ></el-option>
                                </el-select>
                            </div>

                            <el-button type="primary"
                                       @click="onOpenModalProducts">
                                <i class="fa fa-plus"></i>
                                <span class="ml-2">Agregar Producto</span>
                            </el-button>
                        </div>
                        <table class="table mt-2">
                            <thead>
                            <tr>
                                <th>Producto</th>
                                <th class="text-center">Cant.</th>
                                <th class="text-center">Precio</th>
                                <th class="text-right">Importe</th>
                                <th class="text-center">Comprobante</th>
                                <th class="text-center">Estado del pago</th>

                                <th class="text-center">M. Pago</th>
                                <th class="text-center">Destino</th>

                                <th class="text-right"></th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr v-for="(p, index) in form.products"
                                :key="p.item_id">
                                <td>{{ p.item.description }}</td>
                                <td class="text-center">{{ p.quantity | toDecimals }}</td>
                                <td class="text-center">
                                    <!-- {{ p.input_unit_price_value | toDecimals }} -->
                                      {{ p.unit_price | toDecimals }}
                                </td>
                                <td class="text-right">{{ p.total | toDecimals }}</td>

                                <td class="text-center">
                                    {{ p.sale_note ? p.sale_note : '' }}
                                </td>

                                <td class="text-center">
                                    <div class="d-inline-block"
                                         style="max-width: 150px">
                                        <el-select
                                            v-model="p.payment_status"
                                            placeholder="Proceso de pago"
                                            :disabled="p.is_registered"
                                            @change="changePaymentStatus(index)"
                                        >
                                            <el-option label="Cancelado"
                                                       value="PAID"></el-option>
                                            <el-option
                                                label="Cargar a habitación"
                                                value="DEBT"
                                            ></el-option>
                                        </el-select>
                                        <div
                                            v-if="errors.payment_status"
                                            class="form-control-feedback"
                                        >
                                            {{ errors.payment_status[0] }}
                                        </div>
                                    </div>
                                </td>

                                <td style="max-width: 150px">
                                    
                                    <template v-if="isPaid(p)">
                                        <div class="form-group mb-2 mr-2" :class="{ 'has-danger': errors[`products.${index}.rent_payment.payment_method_type_id`] }">
                                            <el-select
                                                v-model="p.rent_payment.payment_method_type_id"
                                                filterable
                                                :disabled="p.is_registered"
                                            >
                                                <el-option
                                                    v-for="option in payment_method_types"
                                                    :key="option.id"
                                                    :value="option.id"
                                                    :label="option.description"
                                                ></el-option>
                                            </el-select>

                                            <small
                                                class="form-control-feedback"
                                                v-if="errors[`products.${index}.rent_payment.payment_method_type_id`]"
                                                v-text="errors[`products.${index}.rent_payment.payment_method_type_id`][0]"
                                            ></small>
                                        </div>
                                    </template>

                                </td>
                                <td style="max-width: 150px">
                                    
                                    <template v-if="isPaid(p)">
                                        <div class="form-group mb-2 mr-2" :class="{ 'has-danger': errors[`products.${index}.rent_payment.payment_destination_id`] }">
                                            <el-select
                                                v-model="p.rent_payment.payment_destination_id"
                                                filterable
                                                :disabled="p.is_registered"
                                            >
                                                <el-option
                                                    v-for="option in payment_destinations"
                                                    :key="option.id"
                                                    :value="option.id"
                                                    :label="option.description"
                                                ></el-option>
                                            </el-select>

                                            <small
                                                class="form-control-feedback"
                                                v-if="errors[`products.${index}.rent_payment.payment_destination_id`]"
                                                v-text="errors[`products.${index}.rent_payment.payment_destination_id`][0]"
                                            ></small>
                                        </div>
                                    </template>
                                </td>

                                <td>
                                    <el-button :disabled="p.is_registered"
                                            type="danger"
                                            @click="onDeleteProduct(index)">
                                        <i class="fa fa-trash"></i>
                                    </el-button>
                                </td>
                            </tr>
                            </tbody>
                            <tfoot v-if="form.products.length > 0">
                            <tr>
                                <td class="text-right" colspan="3">
                                    <strong>SUBTOTAL</strong>
                                </td>
                                <td class="text-right">
                                    <strong>
                                        {{ this.form.subtotal | toDecimals }}
                                    </strong>
                                </td>
                                <td></td>
                                <td></td>
                            </tr>
                            <tr>
                                <td class="text-right" colspan="3">
                                    <strong>IGV</strong>
                                </td>
                                <td class="text-right">
                                    <strong>
                                        {{ this.form.igv | toDecimals }}
                                    </strong>
                                </td>
                                <td></td>
                                <td></td>
                            </tr>
                            <tr>
                                <td class="text-right" colspan="3">
                                    <strong>TOTAL</strong>
                                </td>
                                <td class="text-right">
                                    <strong>
                                        {{ this.form.total | toDecimals }}
                                    </strong>
                                </td>
                                <td></td>
                                <td></td>
                            </tr>
                            <tr>
                                <td colspan="7"></td>
                                <td>
                                    <el-button
                                        :disabled="loading"
                                        :loading="loading"
                                        class="btn-block"
                                        type="primary"
                                        @click="onSubmit"
                                        v-show="showBtnSave"
                                    >
                                        <i class="fa fa-save"></i>
                                        <span class="ml-2">Guardar</span>
                                    </el-button>
                                </td>
                            </tr>
                            </tfoot>
                        </table>

                        <div v-if="errors.products"
                             class="form-control-feedback">
                            {{ errors.products[0] }}
                        </div>
                        <div v-if="this.products.length>0 && form.products.length  < 1"
                             class="pull-right">
                            <el-button
                                :disabled="loading"
                                :loading="loading"
                                class="btn-block"
                                type="primary"
                                @click="onTotalDeleteProduct"
                            >
                                <i class="fa fa-save"></i>
                                <span class="ml-2">Guardar</span>
                            </el-button>
                        </div>

                    </div>
                </div>
            </div>
        </div>
        <tenant-documents-items-list
            :configuration="configuration"
            :editNameProduct="configuration.edit_name_product"
            :exchange-rate-sale="exchange_rate_sale"
            :isEditItemNote="false"
            :recordItem="recordItem"
            :showDialog.sync="showDialogAddItem"
            :typeUser="typeUser"
            :percentageIgv="percentage_igv"
            currency-type-id-active="PEN"
            operation-type-id="0101"
            @add="onAddItem"

        ></tenant-documents-items-list>

        <sale-notes-options :showDialog.sync="showDialogOptions"
                            :recordId="saleNotesNewId"
                            :showClose="true"
                            :configuration="config"
                            ></sale-notes-options>
    </div>
</template>

<script>
// import DocumentFormItem from "../../../../../../../resources/js/views/tenant/documents/partials/item.vue";
import {functions, exchangeRate} from "../../../../../../../resources/js/mixins/functions";
import moment from "moment";
import {mapActions,mapState} from "vuex/dist/vuex.mjs";
import SaleNotesOptions from "../../../../../../../resources/js/views/tenant/sale_notes/partials/options.vue"

export default {
    components: {
        // DocumentFormItem,
        SaleNotesOptions
    },
    mixins: [
        functions,
        exchangeRate
    ],
    props: {
        rent: {
            type: Object,
            required: true,
        },
        products: {
            type: Array,
            required: false,
            default: [],
        },
        configuration: {
            type: Object,
            required: true,
        },
        establishment: {
            type: Object,
            required: true,
        },
        series: {
            type: Array
        }
    },
    data() {
        return {
            title: "",
            showDialogAddItem: false,
            recordItem: null,
            form: {
                products: [],
                subtotal: 0,
                total: 0,
                igv: 0,
                date_of_issue: moment().format("YYYY-MM-DD"),
                establishment_id: null,
                sale_note_id: null,
            },
            errors: {},
            typeUser: "admin",
            loading: false,
            payment_method_types: [],
            payment_destinations: [],
            serie_id: null,
            resource_document: 'sale-notes',
            document: {},
            showDialogOptions: false,
            saleNotesNewId: null,
            number_full: null,
            exchange_rate_sale: 0,
        };
    },
    computed: {
        ...mapState([
            'config',
        ]),

        showBtnSave() {
            return this.form.products.some(item => !item.is_registered)
        }
    },
    mounted() {
        // console.log(this.configuration);
        this.form.establishment_id = this.establishment.id;
        this.getPercentageIgv();
        if (this.products) {
            const products = this.products.map((p) => {
                p.item.payment_status = p.payment_status;
                p.item.is_registered = p.id ? true : false
                p.item.sale_note = p.sale_note ? p.sale_note.series + '-' + p.sale_note.number : ''
                return p.item;
            });
            this.form.products = products;
            this.onCalculateTotals();
        }
        this.serie_id = this.series.length ? this.series[0].id : null

        this.initForm()
    },
    async created() 
    {
        this.loadConfiguration()
        this.exchangeRateSale()
        this.title = `Habitación ${this.rent.room.name} - Agregar productos`;
        await this.getTables()
    },
    methods: {
        ...mapActions([
            'loadConfiguration',
        ]),
        changePaymentStatus(index)
        {
            this.form.products[index].rent_payment.payment_destination_id = null
            this.form.products[index].rent_payment.payment_method_type_id = null
        },
        isPaid(row)
        {
            return row.payment_status === 'PAID'
        },

        exchangeRateSale() {
            this.searchExchangeRateByDate(this.form.date_of_issue).then(response => {
                this.exchange_rate_sale = response
            })
        },

        async getTables()
        {
            this.loading = true
            await this.$http.get('/hotels/reception/rent-products-tables')
                            .then((response) => {
                                this.payment_method_types = response.data.payment_method_types
                                this.payment_destinations = response.data.payment_destinations
                            })
                            .finally(() => {
                                this.loading = false
                            })
        },
        async onSubmit() {
            this.loading = true;
            const products_ = this.form.products
            this.document.items = this.form.products.filter(item => !item.is_registered && item.payment_status === 'PAID')
            if (this.verifyPaidProducts(this.document.items)) {
                await this.saveSaleNote()
                this.form.sale_note_id = this.saleNotesNewId
            }
            
            // solo enviamos los que son nuevos
            this.form.products = this.form.products.filter(item => !item.is_registered)
            this.$http
                .post(
                    `/hotels/reception/${this.rent.id}/rent/products/store`,
                    this.form
                )
                .then((response) => {
                    // window.location.href = "/hotels/reception";
                    this.$message({
                        message: response.data.message,
                        type: "success",
                    });

                    // update is_registered => true, and payments => []
                    this.form.products = products_
                    this.form.products = this.form.products.map((p) => {
                        p.is_registered = true
                        if (p.payment_status === 'PAID' && !p.sale_note) {
                            p.sale_note = this.number_full
                        }
                        return p
                    })
                    this.document.payments = []
                })
                .catch((error) => this.axiosError(error))
                .finally(() => (this.loading = false));
        },

        verifyPaidProducts(products) {
            return products.some((p) => p.payment_status === "PAID")
        },

        onTotalDeleteProduct() {
            this.$confirm(
                "¿Estás seguro de eliminar todos los productos?",
                "Cuidado",
                {
                    confirmButtonText: "Si",
                    cancelButtonText: "No",
                    type: "warning",
                }
            )
                .then(() => {
                    this.onSubmit()
                })
                .catch(() => {
                });
        },
        onDeleteProduct(index) {
            this.$confirm(
                "¿estás seguro de eliminar el producto seleccionado?",
                "Cuidado",
                {
                    confirmButtonText: "Si",
                    cancelButtonText: "No",
                    type: "warning",
                }
            )
                .then(() => {
                    // this.form.products = this.form.products.filter(
                    //     (p) => p.item_id !== product.item_id
                    // );
                    this.form.products.splice(index, 1)

                    this.onCalculateTotals();
                })
                .catch(() => {
                });
        },
        onOpenModalProducts() {
            this.showDialogAddItem = true;
        },
        onCalculateTotals() {
            this.form.subtotal = this.form.products
                .map((p) => p.total_value)
                .reduce((a, p) => a + p, 0);
            this.form.igv = this.form.products
                .map((p) => p.total_igv)
                .reduce((a, p) => a + p, 0);
            // this.form.total = this.form.subtotal + this.form.igv;
            this.form.total = this.form.products.reduce((total, product) => total + product.total, 0)

        },
        getDefaultValuesRentPayment()
        {
            let payment_method_type_id = null
            let payment_destination_id = null

            if(this.payment_method_types.length > 0)
            {
                payment_method_type_id = this.payment_method_types[0].id
            }

            if(this.payment_destinations.length > 0)
            {
                const exist_cash = _.find(this.payment_destinations, { id : 'cash'})
                payment_destination_id = (exist_cash) ? exist_cash.id : this.payment_destinations[0].id
            }

            return {
                payment_method_type_id,
                payment_destination_id
            }
        },
        async onAddItem(product) {

            const { payment_method_type_id, payment_destination_id } = await this.getDefaultValuesRentPayment()

            const newProduct = {
                payment_status: "PAID",
                affectation_igv_type_id: product.affectation_igv_type_id,
                attributes: product.attributes,
                charges: product.charges,
                discounts: product.discounts,
                item_id: product.item_id,
                name_product_pdf: product.name_product_pdf,
                percentage_igv: product.percentage_igv,
                percentage_isc: product.percentage_isc,
                percentage_other_taxes: product.percentage_other_taxes,
                price_type_id: product.price_type_id,
                quantity: product.quantity,
                system_isc_type_id: product.system_isc_type_id,
                total: product.total,
                total_base_igv: product.total_base_igv,
                total_base_isc: product.total_base_isc,
                total_base_other_taxes: product.total_base_other_taxes,
                total_charge: product.total_charge,
                total_discount: product.total_discount,
                total_igv: product.total_igv,
                total_isc: product.total_isc,
                total_other_taxes: product.total_other_taxes,
                total_plastic_bag_taxes: product.total_plastic_bag_taxes,
                total_taxes: product.total_taxes,
                total_value: product.total_value,
                unit_price: product.unit_price,
                unit_value: product.unit_value,
                warehouse_id: product.warehouse_id,
                input_unit_price_value: product.input_unit_price_value,
                // item: {
                //   description: product.item.description,
                //   item_type_id: product.item.item_type_id,
                //   internal_id: product.item.internal_id,
                //   item_code: product.item.item_code,
                //   item_code_gs1: product.item.item_code_gs1,
                //   unit_type_id: product.item.unit_type_id,
                //   presentation: product.item.presentation,
                //   amount_plastic_bag_taxes: product.item.amount_plastic_bag_taxes,
                //   is_set: product.item.is_set,
                //   lots: product.item.lots,
                //   IdLoteSelected: product.item.IdLoteSelected,
                // },
                item: this.getNewItem(product),
                rent_payment: {
                    payment_method_type_id: payment_method_type_id,
                    payment_destination_id: payment_destination_id,
                    reference: null,
                    payment: product.total
                },

                total_original: product.total_original,
                is_registered: false
            };

            const repeteads = this.form.products.filter(
                (p) => p.item_id === newProduct.item_id && !p.is_registered
            );
            if (repeteads.length > 0) {
                this.form.products = this.form.products.map((p) => {
                    if (p.item_id === newProduct.item_id && !p.is_registered) {
                        return newProduct;
                    }
                    return p;
                });
            } else {
                this.form.products.push(newProduct);
            }
            this.onCalculateTotals();
        },
        getNewItem(product) {

            let new_item = product.item

            // new_item.description = product.item.description
            // new_item.internal_id = product.item.internal_id
            // new_item.unit_type_id = product.item.unit_type_id
            // new_item.is_set = product.item.is_set
            // new_item.lots = product.item.lots
            // new_item.amount_plastic_bag_taxes = product.item.amount_plastic_bag_taxes
            new_item.item_type_id = product.item.item_type_id
            new_item.item_code = product.item.item_code
            new_item.item_code_gs1 = product.item.item_code_gs1
            new_item.presentation = product.item.presentation
            new_item.IdLoteSelected = product.item.IdLoteSelected

            return new_item

        },
        onGotoBack() {
            window.location.href = "/hotels/reception";
        },

        initForm() {
            this.document = {
                // serie_id: this.series.length ? this.series[0].id : null,
                document_type_id: '80',

                id: null,
                series_id: this.serie_id,
                prefix: 'NV',
                establishment_id: null,
                due_date: null,
                date_of_issue: moment().format('YYYY-MM-DD'),
                time_of_issue: moment().format('HH:mm:ss'),
                customer_id: null,
                currency_type_id: this.config.currency_type_id,
                purchase_order: null,
                exchange_rate_sale: 0,
                total_prepayment: 0,
                total_charge: 0,
                total_discount: 0,
                total_exportation: 0,
                total_free: 0,
                total_taxed: 0,
                total_unaffected: 0,
                total_exonerated: 0,
                total_igv: 0,
                total_base_isc: 0,
                total_isc: 0,
                total_base_other_taxes: 0,
                total_other_taxes: 0,
                total_taxes: 0,
                total_value: 0,
                subtotal: 0,
                total_igv_free: 0,
                total: 0,
                operation_type_id: null,
                items: [],
                charges: [],
                discounts: [],
                attributes: [],
                guides: [],
                payments: [],
                additional_information: null,
                actions: {
                    format_pdf: 'a4',
                },
                apply_concurrency: false,
                type_period: null,
                quantity_period: 0,
                automatic_date_of_issue: null,
                enabled_concurrency: false,
                license_plate: null,
                payment_method_type_id: null,
                paid: false,
                observation: null,
                terms_condition: null,

                type_device: 'web',

                dcto_monto_input: 0,
                dcto_totales_input: 0,
                monto_pagar_sin_dcto: 0,
                address_id: null,
                source_module: 'HOTEL_PRODUCTS'
            }
        },

        calculateTotal() {
            let total_discount = 0
            let total_charge = 0
            let total_exportation = 0
            let total_taxed = 0
            let total_exonerated = 0
            let total_unaffected = 0
            let total_free = 0
            let total_igv = 0
            let total_value = 0
            let total = 0
            let total_igv_free = 0

            this.document.items.forEach((row) => {
                total_discount += parseFloat(row.total_discount)
                total_charge += parseFloat(row.total_charge)

                if (row.affectation_igv_type_id === '10') {
                    total_taxed += parseFloat(row.total_value)
                }
                if (row.affectation_igv_type_id === '20'  // 20,Exonerado - Operación Onerosa
                    || row.affectation_igv_type_id === '21' // 21,Exonerado – Transferencia Gratuita
                ) {
                    total_exonerated += parseFloat(row.total_value)
                }
                if (
                    row.affectation_igv_type_id === '30'  // 30,Inafecto - Operación Onerosa
                    || row.affectation_igv_type_id === '31'  // 31,Inafecto – Retiro por Bonificación
                    || row.affectation_igv_type_id === '32'  // 32,Inafecto – Retiro
                    || row.affectation_igv_type_id === '33'  // 33,Inafecto – Retiro por Muestras Médicas
                    || row.affectation_igv_type_id === '34'  // 34,Inafecto - Retiro por Convenio Colectivo
                    || row.affectation_igv_type_id === '35'  // 35,Inafecto – Retiro por premio
                    || row.affectation_igv_type_id === '36' // 36,Inafecto - Retiro por publicidad
                    || row.affectation_igv_type_id === '37'  // 37,Inafecto - Transferencia gratuita
                ) {
                    total_unaffected += parseFloat(row.total_value)
                }
                if (row.affectation_igv_type_id === '40') {
                    total_exportation += parseFloat(row.total_value)
                }
                if (['10',
                    '20', '21',
                    '30', '31', '32', '33', '34', '35', '36',
                    '40'].indexOf(row.affectation_igv_type_id) < 0) {
                    total_free += parseFloat(row.total_value)
                }
                if (['10',
                    '20', '21',
                    '30', '31', '32', '33', '34', '35', '36',
                    '40'].indexOf(row.affectation_igv_type_id) > -1) {
                    total_igv += parseFloat(row.total_igv)
                    total += parseFloat(row.total)
                }


                if (['11', '12', '13', '14', '15', '16'].includes(row.affectation_igv_type_id)) {

                    let unit_value = row.total_value / row.quantity
                    let total_value_partial = unit_value * row.quantity
                    row.total_taxes = row.total_value - total_value_partial

                    row.total_igv = total_value_partial * (row.percentage_igv / 100)
                    row.total_base_igv = total_value_partial
                    total_value -= row.total_value

                    total_igv_free += row.total_igv
                }

                total_value += parseFloat(row.total_value)

            })

            this.document.total_igv_free = _.round(total_igv_free, 2)

            this.document.total_discount = _.round(total_discount, 2)
            this.document.total_exportation = _.round(total_exportation, 2)
            this.document.total_taxed = _.round(total_taxed, 2)
            this.document.total_taxed_without_rounding = _.round(total_taxed, 5)
            this.document.total_exonerated = _.round(total_exonerated, 2)
            this.document.total_unaffected = _.round(total_unaffected, 2)
            this.document.total_free = _.round(total_free, 2)
            this.document.total_igv = _.round(total_igv, 2)
            this.document.total_value = _.round(total_value, 2)
            this.document.total_taxes = _.round(total_igv, 2)

            this.document.subtotal = _.round(total, 2)
            this.document.total = _.round(total, 2)

            // this.monto_pagar_sin_dcto = this.document.items.reduce((monto_sin_dcto, item) => monto_sin_dcto + item.total_original, 0)
            this.document.monto_pagar_sin_dcto = this.document.items.reduce((monto_sin_dcto, item) => monto_sin_dcto + item.total_original, 0)
        },

        addPayments() {
            this.document.items.forEach((item) => {
                this.document.payments.push({
                    id: null,
                    document_id: null,
                    date_of_payment: moment().format('YYYY-MM-DD'),
                    payment_method_type_id: item.rent_payment.payment_method_type_id, //'01', // método de pago
                    reference: item.rent_payment.reference, // referencia
                    payment_destination_id: item.rent_payment.payment_destination_id, // this.getPaymentDestinationId(), // destino
                    payment: item.rent_payment.payment, // 0,

                    filename: null,
                    temp_path: null,
                    file_list: [],
                })
            })
        },

        async saveSaleNote() {
            this.calculateTotal()
            this.document.customer_id = this.rent.customer_id
            this.document.establishment_id = this.form.establishment_id
            const main_address = this.rent.customer.address_main || null
            if (main_address) {
                this.document.address_id = main_address
            } else {
                const address = this.rent.customer.addresses.filter(address => address.main)
                this.document.address_id = address.length ? address[0].id : null
            }

            this.addPayments()

            console.log('document')
            console.log(this.document)
            const response = await this.$http.post(`/${this.resource_document}`, this.document)
            if (response.data.success) {
                const { id, cash_id, number_full } = response.data.data
                this.saleNotesNewId = id
                this.number_full = number_full
                this.showDialogOptions = true
                this.$message({
                    message: 'Nota de venta guardada correctamente',
                    type: 'success',
                })
                await this.saveCashDocument(id, cash_id)
                // await this.updateRentItem(rent_item_id, id)
            } else {
                console.log('Error al guardar la nota de venta')
            }
        },

        async saveCashDocument(documentId, cashId) {
            const response = await this.$http.post(`/cash/cash_document`, {
                document_id: null,
                sale_note_id: documentId,
                cash_id: cashId,
            })
        },

        onChangeSerie() {
            this.document.series_id = this.serie_id
        }

    },
};
</script>



// WEBPACK FOOTER //
// modules/Hotel/Resources/assets/js/views/rooms/AddProductToRoom.vue